// Payroll API client helpers for the frontend.
import { api, API_BASE } from "@/lib/api";

export const Payroll = {
  // Dashboard
  dashboard: () => api.get("/payroll/dashboard").then(r => r.data),
  // Settings
  getPF: () => api.get("/payroll/settings/pf").then(r => r.data),
  putPF: (p) => api.put("/payroll/settings/pf", p).then(r => r.data),
  getESI: () => api.get("/payroll/settings/esi").then(r => r.data),
  putESI: (p) => api.put("/payroll/settings/esi", p).then(r => r.data),
  getBonus: () => api.get("/payroll/settings/bonus").then(r => r.data),
  putBonus: (p) => api.put("/payroll/settings/bonus", p).then(r => r.data),
  getGratuity: () => api.get("/payroll/settings/gratuity").then(r => r.data),
  putGratuity: (p) => api.put("/payroll/settings/gratuity", p).then(r => r.data),
  getCycle: () => api.get("/payroll/settings/cycle").then(r => r.data),
  putCycle: (p) => api.put("/payroll/settings/cycle", p).then(r => r.data),
  getRounding: () => api.get("/payroll/settings/rounding").then(r => r.data),
  putRounding: (p) => api.put("/payroll/settings/rounding", p).then(r => r.data),
  listPT: () => api.get("/payroll/settings/pt").then(r => r.data),
  putPT: (state, p) => api.put(`/payroll/settings/pt/${state}`, p).then(r => r.data),
  listTDS: () => api.get("/payroll/settings/tds").then(r => r.data),
  putTDS: (regime, fy, p) => api.put(`/payroll/settings/tds/${regime}/${fy}`, p).then(r => r.data),
  listComponents: () => api.get("/payroll/settings/components").then(r => r.data),
  createComponent: (p) => api.post("/payroll/settings/components", p).then(r => r.data),
  updateComponent: (id, p) => api.put(`/payroll/settings/components/${id}`, p).then(r => r.data),
  // Structures
  listStructures: () => api.get("/payroll/structures").then(r => r.data),
  createStructure: (p) => api.post("/payroll/structures", p).then(r => r.data),
  updateStructure: (id, p) => api.put(`/payroll/structures/${id}`, p).then(r => r.data),
  deleteStructure: (id) => api.delete(`/payroll/structures/${id}`).then(r => r.data),
  // Compensations
  listCompensations: (employee_id) => api.get("/payroll/compensations", { params: { employee_id } }).then(r => r.data),
  saveCompensation: (p) => api.post("/payroll/compensations", p).then(r => r.data),
  // Profile
  getProfile: (eid) => api.get(`/payroll/employees/${eid}/profile`).then(r => r.data),
  putProfile: (eid, p) => api.put(`/payroll/employees/${eid}/profile`, p).then(r => r.data),
  // Runs
  listRuns: () => api.get("/payroll/runs").then(r => r.data),
  createRun: (p) => api.post("/payroll/runs", p).then(r => r.data),
  getRun: (id) => api.get(`/payroll/runs/${id}`).then(r => r.data),
  computeRun: (id, p) => api.post(`/payroll/runs/${id}/compute`, p || {}).then(r => r.data),
  runAction: (id, p) => api.post(`/payroll/runs/${id}/action`, p).then(r => r.data),
  // Payslips
  listPayslips: (employee_id) => api.get("/payroll/payslips", { params: { employee_id } }).then(r => r.data),
  payslipPdfUrl: (id) => `${API_BASE}/payroll/payslips/${id}/pdf`,
  // Declarations
  listDeclarations: (employee_id) => api.get("/payroll/declarations", { params: { employee_id } }).then(r => r.data),
  createDeclaration: (p) => api.post("/payroll/declarations", p).then(r => r.data),
  updateDeclaration: (id, p) => api.put(`/payroll/declarations/${id}`, p).then(r => r.data),
  reviewDeclaration: (id, p) => api.post(`/payroll/declarations/${id}/review`, p).then(r => r.data),
  // Revisions
  listRevisions: (employee_id) => api.get("/payroll/revisions", { params: { employee_id } }).then(r => r.data),
  // Loans
  listLoans: () => api.get("/payroll/loans").then(r => r.data),
  createLoan: (p) => api.post("/payroll/loans", p).then(r => r.data),
  loanAction: (id, p) => api.post(`/payroll/loans/${id}/action`, p).then(r => r.data),
  // Advances
  listAdvances: () => api.get("/payroll/advances").then(r => r.data),
  createAdvance: (p) => api.post("/payroll/advances", p).then(r => r.data),
  advanceAction: (id, p) => api.post(`/payroll/advances/${id}/action`, p).then(r => r.data),
  // FNF
  listFNF: () => api.get("/payroll/fnf").then(r => r.data),
  createFNF: (p) => api.post("/payroll/fnf", p).then(r => r.data),
  // Reports
  reportUrl: (type, run_id) => `${API_BASE}/payroll/reports/${type}${run_id ? `?run_id=${run_id}` : ""}`,
};
